import request from "@/services/request";
import { stringify } from "qs";
import { url } from "../service-utils";

/**
 * 推送设置获取参数
 * @param params
 * @returns {Promise<void>}
 */
export async function getPushConfig(params) {
  return request(`${url.url}/v3/cfg/get?${stringify(params)}`);
}

/**
 * 网站设置保存
 * @param params
 * @returns {Promise<void>}
 */
export async function micrositeConfigSave(params) {
  return request(`${url.url}/v3/cfg/micrositeCfg/save`, {
    method: "post",
    data: params
  });
}

/**
 * 审批设置获取参数
 * @param params
 * @returns {Promise<void>}
 */
export async function getApprovalConfig(params) {
  return request(`${url.url}/news/leave_words/audit_conf/get?${stringify(params)}`);
}

/**
 * 审批设置保存
 * @param params
 * @returns {Promise<void>}
 */
export async function micrositeApprovalSave(params) {
  return request(`${url.url}/news/leave_words/audit_conf/update`, {
    method: "post",
    data: params
  });
}
